import Vue from "vue";

import VueRouter from "vue-router";

Vue.use(VueRouter);
